module.exports = __webpack_public_path__ + "static/media/follow_the_food_farmers_on_front_line.f0db8ff4.jpg";